import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
//import DxGrid from "./DxGrid";
import { fields, gridFieldIndex } from "./gridHelpers/fields";
import "./resultsGrid.css";
import { Paging, Scrolling, Summary, TotalItem, Column, HeaderFilter, Selection, StateStoring } from 'devextreme-react/data-grid';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { format } from 'date-fns';
import {
  setExploreSelectedIds,
  setExplorePropertyDetailsIsOpen,
  updateExploreObjectById,
  fetchExplorePropertyData,
  appNotify
} from 'store/actions';
import { exploreSelectedPropertiesCountSelector } from 'store/selectors';
import { connect } from "react-redux";
import { compose } from "recompose";
import _ from "lodash";
import { LoadIndicator } from 'devextreme-react/load-indicator';
import DataGrid from 'components/devExtreme/DataGrid';
import CustomColumnChooser from 'components/customColumnChooser';
import { propertyGroupLevels } from "api/rex/spatial";
import { cleanState } from 'components/devExtreme/DataGrid';
import dataGridExtension from 'components/devExtreme/dataGridExtension';

const ResultsGrid = (props) => {
  const {
    propertyData,
    isAggregateData,
    groupLevel,
    hasObject,
    objectId,
    selectedIdsContext,
    selectedPropertiesCount,
    selectedSourceVisible,
    gridState,
    needsFilterSet,
    setExploreSelectedIds,
    resultsGridDataUpdate,
    isMainIndicatorVisible,
    isSecondaryIndicatorVisible,
    setExplorePropertyDetailsIsOpen,
    isColumnChooserVisible,
    setIsColumnChooserVisible,
    updateExploreObjectById,
    fetchExplorePropertyData,
    appNotify
  } = props;
  const { openPushPropertiesModal } = props;
  const [dataSource, setDataSource] = useState(null);
  const [gridInitialized, setGridInitialized] = useState(false);
  const gridRef = useRef(null);
  const listenForDivertedChanges = useRef(true);
  const selectRowsDebounced = useCallback( _.debounce((grid, ids) => grid.selectRows(ids, false), 1000), []);//hack to make grid sync better
  const focusRowDebounced = useCallback(_.debounce((grid, selectedRow) => grid.option("focusedRowKey",  selectedRow), 1000), []);//hack to make grid sync better

  const onSetGridRef = g => {
    gridRef.current = g;
    setGridInitialized(true);
  }

  useEffect(() => {
    if (resultsGridDataUpdate?.length && gridRef) {
      gridRef.current.instance.getDataSource()?.store() &&
        gridRef.current.instance.getDataSource().store().push(resultsGridDataUpdate.map(row => {
          return { type: 'update', data: { ...row }, key: row.clusterID }
        }));
    }
  }, [resultsGridDataUpdate, dataSource]);

  useEffect(() => { // Effect for setting grid sort/filter/groupBy/etc via redux
    if (!gridInitialized || objectId == null || !hasObject) return;
    let newState;
    if (!gridState) {
      // newState = null
      const state = gridRef.current.instance.state();
      updateExploreObjectById(objectId, { gridState: { state }});
      return;
    // } else if (gridState.isUpdate) {
    //   const prevState = gridRef.current.instance.state();
    //   const { columnMods, ...rest } = gridState.state;
    //   newState = {
    //     ...prevState,
    //     ...rest
    //   };
    //   if (columnMods?.length) {
    //     columnMods.forEach(columnMod => {
    //       const { field, type, value } = columnMod;
    //       const foundColumn = newState.columns.find(col => col.dataField === field);
    //       if (!foundColumn) return;
    //       foundColumn[type] = value;
    //     });
    //   }
    //   console.log(newState)
    } else {
      newState = gridState.state;
    }
    try {
      if (!gridState.isUpdate) {
        // listenForDivertedChanges.current = false;
      }
      gridRef.current.instance.beginUpdate();
      gridRef.current.instance.option('grouping', { autoExpandAll: !(gridState?.state?.collapseGroups) }); // Expand groups by default unless otherwise specified in redux grid state.
      const cleanedState = cleanState(newState);
      gridRef.current.instance.state(cleanedState); // When switching to a layout with a filter on a deleted column, applying this state will throw grid error E1047, to be caught below
      gridRef.current.instance.endUpdate();
      createDataSource();
    } catch(e) {
      gridRef.current.instance.endUpdate();
      console.log(e)
      appNotify(`Failed to load: ${e.message}`, 'error');
      gridRef.current.instance.option('dataSource', null); // Clear dataSource on error to prevent grid crashing and show user that layout is broken
    }
  }, [gridInitialized, objectId, hasObject]);

  useEffect(() => {
    if (!propertyData) return;

    createDataSource();
  }, [propertyData]);

  useEffect(() => {
    if (gridRef.current) {
      gridRef.current.instance.option("focusedRowIndex", 0);//hack, otherwise first focusedRowKey doesn't work
    }
  }, [gridRef.current]);

  useEffect(() => {
    if (propertyData == null || propertyData.length === 0) {
      return;
    }
    if (gridRef.current) {
      if (selectedIdsContext?.from === 'Map' && selectedIdsContext.mapSelection?.objectId === objectId) {
        focusRowDebounced(gridRef.current.instance,  selectedIdsContext.mapSelection.clusterID);
      }
      if (selectedIdsContext?.from !== 'Grid') {
        const rowsToSelect = selectedIdsContext?.ids ? selectedIdsContext.ids.filter(el => el.objectId === objectId).map(el => el.clusterID) : null;
        selectRowsDebounced(gridRef.current.instance, rowsToSelect ?? []);
      }
    }
  },[gridRef, propertyData, selectedIdsContext?.ids]);

  const createDataSource = () => {
    if (!propertyData) return;
    const newArrayStore = new ArrayStore({
      key: 'clusterID',
      data: propertyData.map(el => {
        return { ...el }
      })
    })
    const newDataSource = new DataSource({
      store: newArrayStore,
      reshapeOnPush: true,
      // pushAggregationTimeout: 200
    });
    setDataSource(newDataSource);
  }

  const onSelectionChanged = ({ selectedRowsData, selectedRowKeys}) => {
    const sortByClusterId = arr => {
      return arr.map(el => el.clusterID).sort();
    }

    const clusterIds = selectedRowsData?.map(r => {
      return { objectId, clusterID: r.clusterID }
    });
    const selectedSourceIds = selectedIdsContext?.ids ? selectedIdsContext.ids.filter(el => el.objectId === objectId) : [];
    if(JSON.stringify(sortByClusterId(clusterIds)) !== JSON.stringify(sortByClusterId(selectedSourceIds))) {
      setExploreSelectedIds({ ids: clusterIds, from: 'Grid', shouldSelectShape: true });
    }
  }

  const selectAll = () => {
    gridRef.current.instance.selectRows(propertyData.map(p => p.clusterID), false);
  }

  const exportAll = () => {
    const timestamp = format(new Date(), '_yyyy-MM-dd_HHmmss');
    const fileName = 'ReVUe_ExploreGridExport' + timestamp;
    dataGridExtension.exportToExcel(gridRef, fileName);
  }

  const handleContextMenu = e => {
    if (e.target === 'content') {
      // e.items can be undefined
      e.items = e.items ?? [];
      if (e.row) {
        const ref = gridRef.current.instance;
        if (!ref.isRowSelected(e.row.key)) {
          ref.selectRows([e.row.key]);
        }
        e.items = getContextItems(e);
      }
    }
  }

  const getContextItems = e => {
    const items = [];
    const propertyCount = e?.row?.data?.propertiesCount;
    const expand = {
      text: 'Expand',
      onItemClick: () => setExplorePropertyDetailsIsOpen(true),
    }

    items.push({
      text: `Select all`,
      onItemClick: selectAll,
      beginGroup: true
    });
    // if(selectedPropertiesCount <= 1000) {
    //   items.push({
    //     text: "Push to ReVUe",
    //     onItemClick: openPushPropertiesModal
    //   });
    // }
    items.push({
      text: `Export all`,
      onItemClick: exportAll
    });

    if (propertyCount === 1) {
      items.push(expand);
    }

    return items;
  }

  const getClusterNameCaption = useCallback(() => {
    if (isAggregateData) {
      return propertyGroupLevels.find(level => level.value === groupLevel)?.caption ?? groupLevel;
    }
    return "Address";
  }, [groupLevel, isAggregateData]);

  const columns = useMemo(() => {
    return (fields.filter(field => field.inMainGrid && field.summaryType).map(field => {
      return <Column
        key={field.dataField}
        caption={field.dataField === "clusterName" ? getClusterNameCaption() : field.caption}
        dataField={field.dataField}
        fixed={field.fixed || false}
        visible={field.isMainGridDefault ?? false}
        sortOrder={field.sortOrder}
        allowSorting={true}
        allowReordering={true}
        width="auto"
        minWidth={field.minWidth}
        format={field.gridFormat}
        visibleIndex={gridFieldIndex[field.dataField]}
        calculateSortValue={rowData => {
          if (rowData[field.dataField] == null) {
            return null; // Converts undefined values to null for sorting purposes (otherwise null is considered as lowest value and undefined as highest value)
          }
          return rowData[field.dataField];
        }}
      />
    }))
  }, [getClusterNameCaption]);

  const summaries = useMemo(() => {
    return (
      fields.map(field => {
        if (field && field.inMainGrid && field.summaryType) {
          let valueFormat = field.gridFormat;
          if (field.dataField === 'yearBuilt') {
            valueFormat = e => e.toFixed(0);
          }
          if (field.dataField === 'asgPropID') {
            valueFormat = { type: 'fixedPoint', precision: 0 }
          }
          return <TotalItem key={field.dataField}
                column={field.dataField}
                summaryType={field.summaryType}
                valueFormat={valueFormat}
                displayFormat={`${field.summaryType}: {0}`}
              />
        }
      })
    )
  }, [fields])

  function handleRowDblClick(e) {
    if (e.data?.propertiesCount === 1) {
      setExplorePropertyDetailsIsOpen(true);
    }
  }

  function onOptionChanged(option) {
    // if (name !== 'hoveredElement') console.log(option)
    const columnChanges = ['visible', 'visibleIndex', 'width', 'groupIndex', 'sortIndex', 'sortOrder'];
    if (
      listenForDivertedChanges.current === true && 
      (option.name === 'filterValue' ||
      // option.fullName.includes('sortOrder') ||
      (option.name === 'columns' && columnChanges.some(el => option.fullName.includes(el)))
    )) {
      setTimeout(() => {
        const state = gridRef.current.instance.state();
        updateExploreObjectById(objectId, { gridState: { state }});
      }, 100)
    }
  }

  function handleColumnChangesApplied() {
    if (selectedSourceVisible && !needsFilterSet) {
      fetchExplorePropertyData({ objectId, shouldFetch: true });
    }
  }

  return (
    <div id={'gridParent'}>
      <LoadIndicator id={'mainIndicator'} height={40} width={40} visible={isMainIndicatorVisible}/>
      <LoadIndicator id={'secondaryIndicator'} height={40} width={40} visible={isSecondaryIndicatorVisible}/>
      <DataGrid
          id={'exploreGridContainer'}
          ref={onSetGridRef}
          // persistState
          dataSource={dataSource}
          showBorders={false}
          showColumnLines={true}
          showRowLines={true}
          hoverStateEnabled={true}
          onSelectionChanged={onSelectionChanged}
          onRowDblClick={handleRowDblClick}
          allowColumnResizing={true}
          columnResizingMode={"widget"}
          columnAutoWidth={false}
          focusedRowEnabled={true}
          onContextMenuPreparing={handleContextMenu}
          onOptionChanged={onOptionChanged}
        >
        {columns}
        <Column
          caption={''}
          dataField={'__placeholder__'}
          allowSorting={false}
          allowReordering={true}
          width="auto"
          visibleIndex={9999}
        />
        <Scrolling
          mode='virtual'
        />
        <Paging
            enabled={false}
            pageSize={isAggregateData && groupLevel !== "Property" ? 25 : 10}
            />
        <Summary
              >
          {summaries}
        </Summary>
        <Selection mode={'multiple'} showCheckBoxesMode={false} />
        <HeaderFilter visible={false} />
        {/* <ColumnChooser enabled={true} mode='select' /> */}
        <StateStoring
          ignoreColumnOptionNames={[]} // Required to enable column state setting when default ColumnChooser is not enabled
        />
      </DataGrid>
      <CustomColumnChooser
        visible={isColumnChooserVisible}
        onHiding={() => setIsColumnChooserVisible(false)}
        onChangesApplied={handleColumnChangesApplied}
        columns={columns}
        gridRef={gridRef}
      />
    </div>
  )

};

function mapState({ exploreViews, exploreData }) {
  const selectedId = exploreViews.selectedView?.propertyDataDisplay?.selectedSourceId;
  const pdo = selectedId != null ? exploreData.propertyDataObjects[selectedId] : null;
  const object = exploreViews.selectedView ? exploreViews.selectedView.objects.find(obj => obj.id === selectedId) : null;
  return {
    hasObject: object != null,
    objectId: selectedId,
    selectedIdsContext: exploreData.selectedIdsContext,
    propertyData: pdo?.propertyData,
    resultsGridDataUpdate: exploreData.resultsGridDataUpdate,
    isAggregateData: pdo?.isAggregateData,
    groupLevel: pdo?.groupLevel,
    isMainIndicatorVisible: pdo?.isMainIndicatorVisible,
    isSecondaryIndicatorVisible: pdo?.isSecondaryIndicatorVisible,
    // selectedPropertiesCount: exploreSelectedPropertiesCountSelector({ exploreData }),
    gridState: object?.gridState,
    needsFilterSet: !object?.isFilterSet
  };
}

const mapDispatch = {
  setExploreSelectedIds,
  setExplorePropertyDetailsIsOpen,
  updateExploreObjectById,
  fetchExplorePropertyData,
  appNotify
}

export default compose(
  connect(mapState, mapDispatch)
)(ResultsGrid);
